import { useCurrency } from '@blend-ed/blendx-platform/hooks';
import { BlendxCard } from '@blend-ed/blendx-ui';
import { getConfig } from "@edx/frontend-platform";
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useMemo } from "react";
import RecommendationsRow from "../../../components/RecommendationsRow";
import { useDiscoverCourses } from "../../../hooks/courses/useFetchCourses";
import courseDataParser from '../../../utils/courseDataParser';
import messages from '../messages';

const RecommendedCourses = ({ intl, search = '', searchTags = [], noData = () => { }, hasData = () => { } }) => {

  const { discoverCourses, loading } = useDiscoverCourses()
  const { symbol } = useCurrency();

  // initial data loading
  const recommendedCourses = discoverCourses ? courseDataParser(discoverCourses) : []


  const filteredRecommendedCourses = useMemo(() => {
    var filteredCourses = recommendedCourses.filter(course => searchTags?.every(tag => course.tags.includes(tag)));
    hasData();
    return search ? filteredCourses.filter(course => course.name.toLowerCase().includes(search.toLowerCase())) : filteredCourses
  }, [recommendedCourses, searchTags, search])

  if (!filteredRecommendedCourses || filteredRecommendedCourses.length === 0) {
    if (!loading) {
      noData();
    }
    return null;
  }

  return (
    <RecommendationsRow title={intl.formatMessage(messages.courses)} seeAllLink={getConfig().DASHBOARD_URL + "discover/courses"}>
      {filteredRecommendedCourses?.slice(0, 4).map((course, index) => (
        <BlendxCard
          key={index}
          link={`/course/${course.id}`}
          title={course.name}
          image={course.imageUrl}
          estimatedTime={course.effort}
          price={course.price}
          currency={symbol}
          type="price"
          variant="course"
          courseId={course.id}
          startDate={course.startDate}
        />
      ))}
    </RecommendationsRow>
  );
};

RecommendedCourses.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(RecommendedCourses);